import { render, staticRenderFns } from "./CollectionBanner.vue?vue&type=template&id=070faa3e&scoped=true&name=collection-banner&"
import script from "./CollectionBanner.vue?vue&type=script&lang=js&"
export * from "./CollectionBanner.vue?vue&type=script&lang=js&"
import style0 from "./CollectionBanner.vue?vue&type=style&index=0&id=070faa3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070faa3e",
  null
  
)

export default component.exports